// extracted by mini-css-extract-plugin
var _1 = "TableOptions_isVisible__367cb";
var _2 = "TableOptions_modalContainerBtnsBlock__adf35";
var _3 = "TableOptions_modalContainerBtnsBlockApplyBtn__39874";
var _4 = "TableOptions_settingPaginationTitle__8eb69";
var _5 = "TableOptions_settingPaginationTitlePages__7a4a8";
var _6 = "TableOptions_wrapperIconDropDown__75d46";
export { _1 as "isVisible", _2 as "modalContainerBtnsBlock", _3 as "modalContainerBtnsBlockApplyBtn", _4 as "settingPaginationTitle", _5 as "settingPaginationTitlePages", _6 as "wrapperIconDropDown" }
